




































import { Component, Vue, Watch } from "vue-property-decorator";
import Native from "@/common/Native";
import request from "@/api/yunyang/index";
import { Toast } from "vant";
import {
  IHouseItem,
  IHouseDetailRes,
  ISwiperDetail
} from "@/api/yunyang/types";
import Base from "@/template/public/Base.vue";
import indexRequest from "@/api/index";
import AppPrompt from "@/components/AppPrompt.vue";
import { wxChatShare } from "@/common/wechat";
import { findNameByWechatAppid } from "@/common/Utils";
@Component({
  components: { AppPrompt }
})
export default class housedetail extends Base {
  private appId: string = "";
  private id: string = "";
  private isOpenInApp: boolean = false;
  detail: IHouseItem = {};
  viewUnit: Array<string> = [
    "",
    "元/㎡",
    "万元/套",
    "元/月",
    "元/季度",
    "元/年"
  ];
  wxAppId = "";
  mounted() {
    this.appId = (this.$route.query.appId as string) || "";
    this.id = (this.$route.query.id as string) || "";
    this.isOpenInApp = ZWY_CLOUD.isOpenInApp();
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    this.getDetail();
    this.getShareInfo(this.appId);
  }
  setWxConfig() {
    wxChatShare(
      this.detail.name,
      this.detail.position,
      window.location.href,
      ""
    );
  }
  getDetail() {
    return request.getHouseDetail(this.id).then((res: IHouseDetailRes) => {
      if (res.code >= 0) {
        this.detail = res.data;
        this.detail.userName = this.detail.telephone.split(",")[0];
        this.detail.tel = this.detail.telephone.split(",")[1];
        // if (ZWY_CLOUD.isOpenInApp()) {
        //   // 设置标题
        //   ZWY_CLOUD.topBarConfig({
        //     isShowTop: 1,
        //     isShowBackBtn: 1,
        //     isShowTitle: this.detail.name,
        //     isShowMoreBtn: "1"
        //   });
        // }
        if (this.detail.type == "3") {
          document.title = "求租详情";
        } else {
          document.title = "求购详情";
        }
      }
    });
  }
}
